export default __webpack_public_path__ + "static/media/extra3.7019819c.png";